export default [
  {
    path: "/F97MvJlLY58wQes61l2cpFgstyER7LUB4imew",
    children: [
   
      {
        path: "cpFgstyER7LUB4imew/:level?",
        name: "myassignedCourseCasView",
        meta: {
          title: "View CAS",
          authRequired: true,
          acc: ["y54231"],
        },
        component: () => import("../views/scores/viewcas.vue"),
      },
      {
        path: "cpFgstyER7LUB092p/:level?",
        name: "entermyCourseCas",
        meta: {
          title: "Enter CAS",
          authRequired: true,
          acc: ["y12687"],
        },
        component: () => import("../views/scores/entercas.vue"),
      },
    ],
  },
];
